import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import adopteUnVillageois from '../../Assets/Images/adopteunvillageoisloup.svg';
import profilePicture from '../../Assets/Images/profile-picture-placeholder.svg';
import SearchBar from '../SearchBar';
import Container, {
  ProfilePicture,
  TitleAndLogo,
  Logo,
  Title,
  Flex,
  ProfileContainer,
  Circle,
  Connection
} from './styles';
import DiscordButton from '../DiscordButton';
import discord from '../../Assets/Images/discord.png';
import isAvatar from '../../utils/isAvatar';

const loginLink = `https://discord.com/api/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_URL}/login&response_type=code&scope=guilds%20email%20identify`;

const Header = ({ toggleModal, isConnected, informations }) => {
  const [inputValue, setInputValue] = useState('');

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  return (
    <Container>
      <Flex>
        <TitleAndLogo>
          <Link to="/">
            <Logo src={adopteUnVillageois} alt="adopte un villageois" />
          </Link>
        </TitleAndLogo>
        {false && window.innerWidth >= 992 && (
          <SearchBar
            placeholder="Filibert, Stella, ..."
            handleChange={handleChange}
            inputValue={inputValue}
            testId="search-input"
            moveToSearch="true"
          />
        )}
        <ProfileContainer>
          <ProfilePicture
            src={informations.discord ? isAvatar(informations) : profilePicture}
            alt="profile picture"
            onClick={isConnected ? toggleModal : () => {}}
          />
          {isConnected && (
            <Circle>
              <CheckCircleIcon
                fontSize="small"
                style={{
                  color: 'hsl(144, 63%, 67%)',
                  background: 'white',
                  borderRadius: '50%',
                  height: '14px',
                  width: '14px',
                }}
              />
            </Circle>
          )}
        </ProfileContainer>
      </Flex>
      {!isConnected && window.innerWidth < 992 ? (
        <Connection>
          <p className="pt-2">
            Connecte-toi avec ton Discord pour accéder à toutes les
            fonctionnalités !
          </p>
          <DiscordButton href={loginLink}>
            <img
              src={discord}
              alt="discord icon"
            />
            <p>Se connecter</p>
          </DiscordButton>
        </Connection>
      ) : null}

    </Container>
  );
};

Header.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  isConnected: PropTypes.bool.isRequired,
  informations: PropTypes.shape({
    discord: PropTypes.shape({
      avatar: PropTypes.string,
      discriminator: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      locale: PropTypes.string.isRequired,
      member: PropTypes.bool.isRequired,
      username: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default Header;
